import { addClass, removeClass } from '@/utils';

export default {
  /**
   * 모달을 열도록 요청한다.
   * @param {*} context
   * @param {Object} option - 옵션 값 { type: '', header: '', message: '', callback: ()=>{}}
   */
  openModal(context, option) {
    context.commit('OPEN_MODAL', option);
    addClass(document.body, 'scroll_hide_modal');
  },
  /**
   * 데이터 모달을 닫도록 요청한다.
   * @param {*} context
   */
  closeDataModal(context) {
    context.commit('CLOSE_DATA_MODAL');
    removeClass(document.body, 'scroll_hide_modal');
  },
  /**
   * 모달을 닫도록 요청한다.
   * @param {*} context
   */
  closeModal(context) {
    context.commit('CLOSE_MODAL');
    removeClass(document.body, 'scroll_hide_modal');
  },
};
